export const INITIALIZE = "INITIALIZE"
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const UPDATE_LOADING = "UPDATE_LOADING";
export const SET_WEATHER = "SET_WEATHER";
export const UPDATE_PERSONAL_LINKS = "UPDATE_PERSONAL_LINKS";
export const UPDATE_WORK_LINKS = "UPDATE_WORK_LINKS";
export const UPDATE_TODOS = "UPDATE_TODOS";